/*
 * Copyright (c) 2020 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */
export const CONTENT_TYPE_JSON = { "content-type": "application/json" };

export enum RequestMethod {
    POST = "POST",
    DELETE = "DELETE",
    PUT = "PUT",
}
